<template>
<div class="wrap-container cllect-con">
  <div class="header" v-if="!isApp">
    <a href="javascript:void (0)" class="back" @click="backToExam"></a>
    <h1>题目收藏</h1>
  </div>
  <div class="as-Tit" v-if="quesTypeArr && quesTypeArr.length>0">
    <div v-swiper:kmSwiper="kmSwiperOpt" class="subTit">
      <ul class="swiper-wrapper">
        <li
          v-for="(item,index) in quesTypeArr"
          :key="index"
          class="swiper-slide"
          :class="{'on':item.isChoose===1}"
          @click="changeType(index)">
          {{ item.categoryName }}
          <i></i>
        </li>
      </ul>
    </div>
  </div>

  <div class="as-analysis asTab">
    <!--题目分类-->
    <div class="classify" v-if="quesTypeArr && quesTypeArr.length>0">
      <div class="listBox clearfix">
        <b class="fdtit">考场</b>
        <div>
          <span
            class="iconTxt"
            :class="{'on':item.isChoose===1}"
            v-for="(item,index) in medMajors"
            :key="index"
            @click="changeMajor(index)">{{item.showName}}
          </span>
        </div>

      </div>
    </div>
    <!--收藏题目-->
    <div class="test-subject" v-if="quesTypeArr && quesTypeArr.length>0">
      <div class="pub_layout">
        <div v-for="(item,index) in questtionsArr" :key="index">
          <!--答题套小题-->
          <template v-if="item.childs && item.childs.length>0">
            <div class="subBox clearfix">
              <div class="subBox-tit">{{ index+1 }}、<span v-html="item.content"></span></div>
            </div>
            <div v-for="(obj,idx) in item.childs" :key="idx" class="subBox clearfix">
              <div v-if="obj.isFav == 1 || obj.otherFlag">
                <div v-if="obj.quesTypeID ===1 || obj.quesTypeID === 3">
                  <div class="subBox-tit">{{ index+1}}.{{idx+1}}、<span v-html="obj.content"></span></div>
                  <div class="subBox-oneCon">
                    <div v-for="(option,idx1) in obj.options" :key="idx1" :class="obj.optionFlag==1?'option-li':'list'">
                      <span :class="{'on':obj.isRight}">
                        <input
                            :id="`${obj.questionID}_${obj.sequence}`"
                            type="radio"
                            name="singleAndJudge"
                            :value="option.quesValue"
                            @click="radioToggle(obj,option.quesValue)"
                        />
                        {{ option.quesValue }}、{{ option.quesOption }}</span>
                    </div>
                  </div>
                  <div class="subBox-botCon">
                    <a class="collectionBtn as-an fr on" href="javascript:void(0)" @click="openDia(obj.questionUserCollecID)" v-if="obj.isFav === 1">取消收藏</a>
                    <a class="collectionBtn as-an fr " href="javascript:void(0)" @click="addCollect(obj)" v-if="obj.isFav === 0">收藏</a>
                  </div>
                </div>
              </div>
              <div v-if="obj.quesTypeID ===2">
                <div class="subBox-oneCon">
                  <div v-for="(option,idx1) in obj.options" :key="idx1" :class="obj.optionFlag==1?'option-li':'list'">
                      <span :class="{'on':obj.isRight}">
                        <input
                            :id="`${obj.questionID}_${obj.sequence}`"
                            type="checkbox"
                            name="multiple"
                            :value="obj.quesValue"
                            :checked="hasChecked(obj.userAnswer, obj.quesValue)"
                        />
                        {{ option.quesValue }}、{{ option.quesOption }}</span>
                  </div>
                </div>
                <div class="subBox-botCon">
                  <a class="collectionBtn as-an fr on" href="javascript:void(0)" @click="openDia(obj.questionUserCollecID)" v-if="obj.isFav === 1">取消收藏</a>
                  <a class="collectionBtn as-an fr " href="javascript:void(0)" @click="addCollect(obj)" v-if="obj.isFav === 0">收藏</a>
                </div>
              </div>
              <div class="saglkd" v-if="obj.isFav == 1 || obj.otherFlag">
                <div class="saglkd-top clearfix " v-bind:class="obj.open?'answerItem':'activeItem'">
                  <a class="p_style" href="javascript:void(0)" @click="submitAnswer(obj)">{{obj.analysisMsg}}</a>
                </div>
              </div>
              <div class="subBox-answerCon" v-if="obj.open">
                <div class="satit clearfix">
                  <b class="clv">正确答案：{{ obj.rightAnswer }}</b>
                  <b class="chong">你的答案：{{ obj.userAnswer }}</b>
                </div>
                <div class="satxt">
                  <i class="fd"></i>
                  <b>答案解析：</b>
                  <span v-html="obj.analysis"></span>
                </div>
                <div class="saglkd">
                  <div class="saglkd-top clearfix">
                    <i class="fd"></i>
                    <b>关联考点：</b>
                    <span class="icon" v-for="(point,idx2) in obj.points" :key="idx2"><a href="javascript:void(0)">{{ point.pointName }}</a></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="saglkd wtachItem">
              <div class="saglkd-top clearfix ">
                <a class="p_style watchOther" href="javascript:void(0)" @click="openOtherQues(item)">{{item.showMsg}}</a>
              </div>
            </div>
          </template>
          <!--单多判-->
          <template v-else>
            <div class="subBox clearfix">
              <div class="subBox-tit">{{ index+1 }}、<span v-html="item.content"></span></div>
              <div class="subBox-oneCon">
                <div v-if="item.quesTypeID ===2">
                  <div class="list" v-for="(option,idx1) in item.options" :key="idx1" :class="{'on':item.isRight}">
                    <span :class="{'on':item.isRight}">
                      <input
                          :id="`${option.questionID}_${option.sequence}`"
                          type="checkbox"
                          name="multiple"
                          :value="option.quesValue"
                          @click="checkboxToggle(item,$event)"
                      />
                    {{ option.quesValue }}、{{ option.quesOption }}</span>
  <!--                  <span :class="{'on':item.isRight}"><i class="icon"></i>{{ option.quesValue }}、{{ option.quesOption }}</span>-->
                  </div>
                </div>
                <div v-if="item.quesTypeID ===1 || item.quesTypeID === 3">
                  <div class="list" v-for="(option,idx1) in item.options" :key="idx1">
                      <span :class="{'on':item.isRight}">
                        <input
                            :id="`${option.questionID}_${option.sequence}`"
                            type="radio"
                            name="singleAndJudge"
                            :value="option.quesValue"
                            @click="radioToggle(item,option.quesValue)"
                        />
                        {{ option.quesValue }}、{{ option.quesOption }}</span>
                  </div>
                </div>
              </div>
              <div class="saglkd">
                <div class="saglkd-top clearfix " v-bind:class="item.open?'answerItem':'activeItem'">
                  <a class="p_style"  href="javascript:void(0)" @click="submitAnswer(item)">{{item.analysisMsg}}</a>
                </div>
              </div>
              <div class="subBox-answerCon" v-if="item.open">
                <div class="satit clearfix">
                  <b class="clv">正确答案：{{item.rightAnswer}}</b>
<!--                  <b class="chong">你的答案：{{item.userAnswer}}</b>-->
                </div>
                <div class="satxt">
                  <i class="fd"></i>
                  <b>答案解析：</b>
                  <span v-html="item.analysis"></span>
                </div>
                <div class="saglkd">
                  <div class="saglkd-top clearfix">
                    <i class="fd"></i>
                    <b>关联考点：</b>
                    <span class="icon" v-for="(point,idx2) in item.points" :key="idx2"><a href="javascript:void(0)">{{ point.pointName }}</a></span>
                  </div>
                </div>
              </div>
              <div class="subBox-botCon"><a class="collectionBtn as-an fr on" href="javascript:void(0)" @click="openDia(item.questionUserCollecID)">取消收藏</a></div>
            </div>
          </template>
        </div>

      </div>
    </div>

    <div class="nodata" v-if="noData">
      <div class="nullBox " >
        <div class="nullBox-pic"><img src="//m.med66.com/OtherItem/images/2020mokaoxitong/null_02.png"></div>
        <div class="nullBox-txt">您还没收藏题目</div>
        <a href="javascript:void (0)" class="nullBox-btn" @click="backToExam">去答题</a>
      </div>
    </div>

  </div>

  <!--取消收藏弹框-->
  <div class="cancel-dia" v-show="cancelDia">
    <div class="mask" ></div>
    <transition name="fade" >
      <div class="scTk clearfix">
        <a href="javascript:void(0)" class="xx" @click="cancelDia = false"></a>
        <div class="ttit">是否取消收藏</div>
        <div class="subtit">&nbsp;</div>
        <div class="hbox clearfix">
          <a href="javascript:void(0)" class="btn" @click="cancelCollect">确 定</a>
          <a href="javascript:void(0)" class="btn btn02" @click="cancelDia = false">取 消</a>
        </div>
      </div>
    </transition>
  </div>
  <div class="loading" v-if="loading">
    <van-loading type="spinner" color="#999" />
  </div>
</div>
</template>

<script>
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { getFavs,getFavCategoryMajors,deleteFavQues,addFavQues } from '@/api'
import { getCookie } from "@/utils";
export default {
  name: "index",
  directives: {
    swiper: directive
  },
  data(){
    return{
      kmSwiperOpt: {
        slidesPerView: 'auto',
        freeMode: true,
        observer: true,
        observeParents: true
      },
      cancelDia:false,
      questtionsArr:[],
      quesTypeArr:[],
      medMajors:[],
      questionUserCollecID:null, //收藏id
      courseID: null,
      isApp:false,
      loading:false,
      noData:false
    }
  },
  mounted() {
    this.getFavCategoryMajorsApi()
    this.isApp = window.CDEL.isApp
  },
  methods: {
    //获取类别
    getFavCategoryMajorsApi(){
      let params = {
        userID:Number(getCookie('cdeluid')) || Number(this.$route.query.userID),
      }
      getFavCategoryMajors(params).then(res => {
        this.quesTypeArr = res
        if(res && res.length>0){
          this.medMajors = res[0].medMajors
          this.courseID = this.medMajors[0].courseID
          this.getFavsApi()
        }else{
          this.noData = true
        }
      })
    },
    //获取题目
    getFavsApi(){
      this.loading = true
      let params = {
        userID:Number(getCookie('cdeluid')) || Number(this.$route.query.userID),
        courseID:this.courseID,
        isAll:1
      }
      getFavs(params).then(res => {
        res.questions.forEach(e => {
          e.analysisMsg = '提交答案并查看解析'
          e.showMsg = '查看本题其他小题'
          e.showFlag = true
          e.open = false
          if (e.childs && e.childs.length >0) {
            e.childs.forEach(v => {
              v.analysisMsg = '提交答案并查看解析'
              v.open = false;
              v.otherFlag = false
              if (v.isFav == 1) v.otherFlag = true
              if (!v.options[0].quesOption) v.optionFlag = 1
              else v.optionFlag = 0
            })
          }
        })
        this.questtionsArr = res.questions
        this.loading = false
      })
    },
    //切换类别
    changeType(index){
      this.quesTypeArr.forEach((val,idx) =>{
        if(idx===index){
          val.isChoose = 1
        }else{
          val.isChoose = 0
        }
      })
      this.medMajors = this.quesTypeArr[index].medMajors
      this.medMajors[0].isChoose = 1
      this.courseID = this.medMajors[0].courseID
      this.getFavsApi()
    },
    //切换考场
    changeMajor(index){
      this.medMajors.forEach((val,idx) =>{
        if(idx===index){
          val.isChoose = 1
          this.courseID = val.courseID
        }else{
          val.isChoose = 0
        }
      })
      this.getFavsApi()

    },
    radioToggle(obj,quesValue) {
      obj.userAnswer = quesValue;
      console.log(obj.userAnswer)
    },
    submitAnswer(obj) {
      if (!obj.open && obj.userAnswer){
        obj.open = true
        obj.analysisMsg = '收起答案解析'
      }else if (!obj.open && !obj.userAnswer){
        alert("请先作答")
      }else if (obj.open) {
        obj.analysisMsg = '提交答案并查看解析'
        obj.open = false
      }

    },
    //查看其他小题
    openOtherQues(obj) {
      if (obj.showFlag) {
        obj.showFlag = false;
        obj.showMsg = '收起本题其他小题'
        obj.childs.forEach(v => {
          if (!v.isFav) {
            v.otherFlag = true;
          }
        })
      }else {
        obj.showFlag = true;
        obj.showMsg = '查看本题其他小题'
        obj.childs.forEach(v => {
          if (!v.isFav) {
            v.open = false
            v.otherFlag = false;
          }
        })
      }

    },
    // 多选选择
    checkboxToggle(item,e) {
      let value = item.userAnswer?item.userAnswer : ''
      if (e.target.checked) {
        value += e.target.value
      }else {
        value = value.split(e.target.value).join("");
      }
      item.userAnswer = value
      console.log(value)
    },
    openDia(questionUserCollecID){
      this.cancelDia = true
      this.questionUserCollecID = questionUserCollecID
    },
    //取消收藏
    cancelCollect(){
      let params = {
        userID:Number(getCookie('cdeluid')) || Number(this.$route.query.userID),
        questionCollectionIDs:[this.questionUserCollecID]
      }
      deleteFavQues(params).then(res => {
        this.cancelDia = false
        this.getFavsApi()
      })
    },
    //添加收藏
    addCollect(obj) {
      let params = {
        userID:Number(getCookie('cdeluid')),
        courseID:this.courseID,
        questionID:obj.questionID,
        chapterID:obj.chapterID
      }
      addFavQues(params).then(res => {
        obj.isFav = 1
        //this.cancelDia = false
        //this.getFavsApi()
      })
      console.log(params)
    },
    backToExam(){
      this.$router.push({
        path:'/entry'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.wtachItem{
  padding:0 30px ;
}

.watchOther{
  color: #4ab83e;
}
.saglkd{
  overflow: hidden;
  .activeItem{
    height: 34px;
    text-align: center;
    line-height: 34px;
    border: 1px solid #4ab83e;
    margin-right: 10px;
    width: 220px;
    display: inline-block;
    border-radius: 18px;
    float: right;
    background: url('../../assets/images/doExam/answerCard-toggle.png') no-repeat right -8px;
    background-position: right center;
    .p_style{
      color: #4ab83e;
    }
  }
  .answerItem{
    height: 34px;
    text-align: center;
    line-height: 34px;
    border: 1px solid #4ab83e;
    margin-right: 10px;
    width: 220px;
    display: inline-block;
    border-radius: 18px;
    float: right;
    background: url('../../assets/images/doExam/answerCard-toggle.png') no-repeat right -8px;
    background-position: right -0.0333rem;
    .p_style{
      color: #4ab83e;
    }
  }
}

.header{
  margin-bottom:0;
}
.as-Tit {
  height: 1.2rem;
  background: #f8f8f8;
  position: relative;
  z-index: 9;
  .swiper-slide {
    position: relative;
    z-index: 1;
    height: 1.2rem;
    line-height: 1.2rem;
    font-size: 0.427rem;
    color: #666;
    width: auto !important;
    margin-left: 0.4rem;
    &.on {
      color: #3EC93E;
    }
  }
}
.as-analysis {
  background: #fff;

  .nullBox-pic {
    display: block;
    width: 6.24rem;
    height: 4.707rem;
    margin: 0 auto 0.48rem;
  }
  .nullBox-txt {
    text-align: center;
    line-height: 0.587rem;
    font-size: 0.427rem;
    color: #666;
    margin-bottom: 0.4rem;
  }
  .nullBox-btn {
    display: block;
    width: 3.68rem;
    height: 1.067rem;
    line-height: 1.067rem;
    text-align: center;
    font-size: 0.427rem;
    color: #fff;
    background: #3ec93e;
    border-radius: 0.533rem;
    margin: 0 auto;
  }
}

.as-analysis {
  background: #fff;
  .classify {
    margin: 0 0.4rem;
    padding: 0.267rem 0;
    background: #fff;
    border-radius: 0.107rem;
    -webkit-box-shadow: 0 0 0.133rem rgba(236, 236, 236, 1);
    -moz-box-shadow: 0 0 0.133rem rgba(236, 236, 236, 1);
    box-shadow: 0 0 0.133rem rgba(236, 236, 236, 1);
    .listBox {
      clear: both;
      padding-left: 1.12rem;
      margin: 0 0.533rem 0.133rem;
      position: relative;
      z-index: 1;
      .fdtit {
        position: absolute;
        top: 0.34rem;
        left: 0;
        height: 0.373rem;
        line-height: 0.373rem;
        font-size: 0.32rem;
        color: #999;
        font-weight: 400;
        background: url(//m.med66.com/OtherItem/images/2020mokaoxitong/icon_17.png) repeat-x left bottom;
        background-size: 1px 0.373rem;
      }
      .fdtit02 {
        top: 0.25rem;
      }
      .iconTxt {
        display: block;
        width: 100%;
        height: 1.04rem;
        line-height: 1.04rem;
        font-size: 0.427rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
        &.on {
          color: #4ab83e;
        }
        &.no {
          color: #999;
          cursor: default;
        }
      }
      .iconBtn {
        float: left;
        display: block;
        padding: 0 0.333rem;
        height: 0.773rem;
        line-height: 0.773rem;
        font-size: 0.373rem;
        white-space: nowrap;
        margin: 0 0.133rem 0.133rem 0;
        border-radius: 0.053rem;
        cursor: pointer;
        background: #f3f6f4;
        border: 1px solid #bfbfbf;
        &.on {
          background: #eafbf2;
          border: 1px solid #7bc9aa;
        }
      }
    }
  }
  .subBox-tit {
    padding: 0.4rem;
    line-height: 0.64rem;
    font-size: 0.427rem;
  }
  .subBox-oneCon {
    overflow: hidden;
    .list {
      clear: both;
      padding: 0.267rem 0.4rem;
      span {
        display: inline-block;
        position: relative;
        z-index: 1;
        padding-left: 1.253rem;
        line-height: 0.8rem;
        font-size: 0.427rem;
        cursor: pointer;
        .icon {
          position: absolute;
          top: 0;
          left: 0;
          display: block;
          width: 0.747rem;
          height: 0.747rem;
          line-height: 0.747rem;
          text-align: center;
          font-size: 0.427rem;
          font-weight: 700;
          background: #fff;
          border: 0.027rem solid #e3e3e3;
          border-radius: 50%;
        }
      }
      &.on {
        background: #eafbf2;
        span {
          .icon {
            background: #3ec93e;
            border: 0.027rem solid #3ec93e;
            color: #fff;
          }
        }
      }
      &.no {
        background: #fbeaea;
        span {
          .icon {
            background: #ff3b3b;
            border: 0.027rem solid #ff3b3b;
            color: #fff;
          }
        }
      }
    }
  }
  .subBox-manyCon {
    .list {
      clear: both;
      padding: 0.267rem 0.4rem;
      span {
        display: inline-block;
        position: relative;
        z-index: 1;
        padding-left: 1.253rem;
        line-height: 0.8rem;
        font-size: 0.427rem;
        cursor: pointer;
        .icon {
          position: absolute;
          top: 0;
          left: 0;
          display: block;
          width: 0.747rem;
          height: 0.747rem;
          line-height: 0.747rem;
          text-align: center;
          font-size: 0.427rem;
          font-weight: 700;
          background: #fff;
          border: 0.027rem solid #e3e3e3;
          border-radius: 0.053rem;
        }
      }
      &.on {
        background: #eafbf2;
        span {
          .icon {
            background: #3ec93e;
            border: 0.027rem solid #3ec93e;
            color: #fff;
          }
        }
      }
      &.no {
        background: #fbeaea;
        span {
          .icon {
            background: #ff3b3b;
            border: 0.027rem solid #ff3b3b;
            color: #fff;
          }
        }
      }
    }
  }
  .subBox-answerCon {
    padding-top: 0.667rem;
    .satit {
      height: 1.333rem;
      line-height: 1.333rem;
      font-size: 0.427rem;
      padding: 0 0.733rem;
      margin-bottom: 0.333rem;
      background: #f9f9f9;
      .clv {
        color: #4ab83e;
        margin-right:0.267rem;
      }
      .chong {
        color: #ff5353;
      }
    }
    .satxt {
      position: relative;
      z-index: 1;
      line-height: 0.667rem;
      font-size: 0.427rem;
      margin: 0 0.733rem 0.56rem;
      .fd {
        position: absolute;
        top: 0.267rem;
        left: -0.333rem;
        width: 0.133rem;
        height: 0.133rem;
        background: #3ec93e;
        border-radius: 50%;
      }
    }
    .saglkd {
      overflow: hidden;
      position: relative;
      z-index: 1;
      margin: 0 0.733rem;
      .fd {
        position: absolute;
        top: 0.267rem;
        left: -0.333rem;
        width: 0.133rem;
        height: 0.133rem;
        background: #3ec93e;
        border-radius: 50%;
      }
    }
    .saglkd-top {
      line-height: 0.667rem;
      font-size: 0.427rem;
      margin-bottom: 0.4rem;
      .icon {
        display: inline-block;
        padding: 0 0.267rem;
        height: 0.64rem;
        line-height: 0.64rem;
        font-size: 0.373rem;
        color: #3ec93e;
        background: #fff;
        border: 1px solid #3ec93e;
        border-radius: 0.107rem;
        margin: 0 0 0.133rem 0.133rem;
        a {
          color: #3ec93e;
        }
      }
    }
    .saglkd-cen {
      .list {
        width: 8.533rem;
        margin-bottom: 0.2rem;
      }
      .list-pic {
        width: 8.533rem;
        height: 4.8rem;
        border-radius: 0.053rem;
        .videoPic {
          position: relative;
          z-index: 1;
          width: 8.533rem;
          height: 4.8rem;
          cursor: pointer;
          i {
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -0.6rem 0 0 -0.6rem;
            display: block;
            width: 1.2rem;
            height: 1.2rem;
            background: url(//m.med66.com/OtherItem/images/2020mokaoxitong/icon_06.png) no-repeat;
            background-size: 100% 100%;
          }
          img {
            width: 8.533rem;
            height: 4.8rem;
          }
        }
        .aPic {
          display: block;
          width: 8.533rem;
          height: 4.8rem;
          img {
            width: 8.533rem;
            height: 4.8rem;
          }
        }
      }
      .list-txt {
        display: block;
        line-height: 1.28rem;
        font-size: 0.427rem;
        height: 1.28rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .subBox-botCon {
    height: 0.667rem;
    margin: 0 0.733rem 0.533rem;
    .collectionBtn {
      padding: 0.1rem 0.1rem 0.1rem 0.8rem;
      height: 0.667rem;
      line-height: 0.72rem;
      font-size: 0.373rem;
      color: #333;
      background: url(//m.med66.com/OtherItem/images/2020mokaoxitong/icon_07.png) no-repeat left center;
      background-size: 0.56rem 0.533rem;
      &.on {
        padding: 0.1rem 0.1rem 0.1rem 0.8rem;
        background: url(//m.med66.com/OtherItem/images/2020mokaoxitong/icon_08.png) no-repeat left center;
        background-size: 0.56rem 0.533rem;
        color: #3ec93e;
      }
    }
  }
}
.nodata{
  position: fixed;
  background: #fff;
  top:0;
  bottom:0;
  width: 100%;
  .nullBox{
    position: relative;
    top:4.8rem;
  }
}
.option-li {
  float: left;
  margin-right: 0.5rem;
  clear: none !important;
}
.option-li:nth-of-type(1){
  margin-left: 0.4rem !important;
}

</style>
